import { useState, useEffect, useCallback } from 'react';
import { SEARCH_DEBOUNCE_MS } from '../constants';

export const useSearchHandler = (onSearch) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [searchProgress, setSearchProgress] = useState(0);

  const handleSearchChange = useCallback((value) => {
    setSearchTerm(value);
    
    // Clear existing timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    // Reset progress
    setSearchProgress(0);
    
    // Start progress animation
    const startTime = Date.now();
    const duration = SEARCH_DEBOUNCE_MS;
    
    const updateProgress = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min((elapsed / duration) * 100, 100);
      setSearchProgress(progress);
      
      if (progress < 100) {
        requestAnimationFrame(updateProgress);
      }
    };
    
    requestAnimationFrame(updateProgress);
    
    // Set new timeout
    const newTimeout = setTimeout(() => {
      onSearch(value);
      setSearchProgress(0); // Reset progress after search
    }, SEARCH_DEBOUNCE_MS);
    
    setSearchTimeout(newTimeout);
  }, [searchTimeout, onSearch]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, [searchTimeout]);

  return {
    searchTerm,
    searchProgress,
    handleSearchChange,
    setSearchTerm
  };
};